module.exports = __webpack_public_path__ + "img/roadmap2.b3c29115.png";